import axios from "axios";

const BASE = process.env.REACT_APP_API_URL + "/api/absensi/bulk";

export const bulkInsertAbsensi = (payload) => axios.post(`${BASE}`, payload);

export const bulkUpdateAbsensi = (payload) =>
  axios.put(`${BASE}/update/`, payload);

export const bulkDeleteAbsensi = (ids) =>
  axios({
    method: "delete",
    url: `${BASE}/delete/`,
    data: { ids },
  });

export const getAbsenKaryawan = async (periode,id) => {
   try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/absensi/periode/list?monthYear=${periode}&emp_id_karyawan=${id}`);
    return res.data.status ? res.data.data : [];
  } catch (err) {
    console.error('fetchJabatan error', err);
    return [];
  }
};
